$(".homefilter").on("click", function () {
  var gender = $(".gender-link.selected").data("link");
  var style = $(".style-link.selected").data("link");
  var compression = $(".compression-link.selected").data("link");
  var germent = $(".germent-link.selected").data("link");
  console.log(gender);
  console.log(style);
  var startl = 0;
  var url = "collections/all/";
  if (gender != undefined) {
    url += gender;
    startl = 1;
  }
  if (style != undefined) {
    url += (startl ? "+" : "") + style;
    startl = 1;
  }
  if (compression != undefined) {
    url += (startl ? "+" : "") + compression;
    startl = 1;
  }
  if (germent != undefined) {
    url += (startl ? "+" : "") + germent;
    startl = 1;
  }
  console.log(url);
  window.location.href = url;
});
$(".gender-link").on("click", function () {
  if ($(this).hasClass("selected")) {
    $(".gender-link").removeClass("selected");
  } else {
    $(".gender-link").removeClass("selected");
    $(this).addClass("selected");
  }
});
$(".style-link").on("click", function () {
  if ($(this).hasClass("selected")) {
    $(".style-link").removeClass("selected");
  } else {
    $(".style-link").removeClass("selected");
    $(this).addClass("selected");
  }
});
$(".compression-link").on("click", function () {
  if ($(this).hasClass("selected")) {
    $(".compression-link").removeClass("selected");
  } else {
    $(".compression-link").removeClass("selected");
    $(this).addClass("selected");
  }
});
$(".germent-link").on("click", function () {
  if ($(this).hasClass("selected")) {
    $(".germent-link").removeClass("selected");
  } else {
    $(".germent-link").removeClass("selected");
    $(this).addClass("selected");
  }
});

function footerDropdown() {
  if ($(window).width() < 750) {
    if ($("footer").length) {
      $(".footer-block__heading")
        .off("click")
        .on("click", function (e) {
          e.preventDefault();
          $(".footer-block__heading")
            .not(this)
            .removeClass("active")
            .next("ul.footer-block__details-content")
            .slideUp();
          $(this).toggleClass("active");
          $(this).next("ul.footer-block__details-content").slideToggle();
        });
    }
  } else {
    // Remove click event on larger screens
    $(".footer-block__heading").off("click");
    $(".footer-block__details-content").removeAttr("style"); // Reset inline styles
  }
}

// Run on page load
$(document).ready(footerDropdown);

// Run on window resize
$(window).resize(footerDropdown);


// click to go product-description section
function updateScrollPadding() {
  const screenWidth = window.innerWidth;
  let offset = 0; // Default offset for larger screens

  if (screenWidth < 1040) { // Adjust for smaller screens
    offset = 50;
  }

  // Apply dynamic scroll-padding-top to the HTML element
  document.documentElement.style.scrollPaddingTop = `${offset}px`;

  // Return the offset value for use in scrolling function
  return offset;
}

function scrollToDescription() {
  const section = document.querySelector('.mainproduct-description');
  const offset = updateScrollPadding(); // Get dynamic offset

  if (section) {
    // Get the absolute position of the section
    const sectionTop = section.getBoundingClientRect().top + window.scrollY;

    // Scroll smoothly with an adjusted offset
    window.scrollTo({
      top: sectionTop - offset,
      behavior: 'smooth'
    });
  }
}

// Run once on page load
document.addEventListener("DOMContentLoaded", updateScrollPadding);

// Update padding dynamically when resizing the window
window.addEventListener("resize", updateScrollPadding);


// product sidebar filter
document.addEventListener("DOMContentLoaded", () => {
  const sidebarMain = document.querySelector(".productgrid--sidebar");
  if (!sidebarMain) return; // Prevent errors if the element is not found

  const titleSmall = sidebarMain.querySelectorAll(
    ".productgrid--sidebar-title--small"
  );

  const titleMenu = sidebarMain.querySelectorAll(".productgrid--sidebar-title");

  titleSmall.forEach((e) => {
    e.addEventListener("click", () => {
      e.classList.toggle("close");
      e.nextElementSibling.classList.toggle("close");
    });
  });

  titleMenu.forEach((e) => {
    e.addEventListener("click", () => {
      e.classList.toggle("close");
      e.nextElementSibling.classList.toggle("close");
    });
  });
});




document.addEventListener("DOMContentLoaded", function () {
  // Get the "See more" link and the filter items with the "filter-item--hidden" class
  let filterGroups = document.querySelectorAll(".filter-group");
  filterGroups.forEach((filterGroup) => {
    let seeMoreLink = filterGroup.querySelector(".filter-item--toggle-more a");
    let filterItems = filterGroup.querySelectorAll(".filter-item--hidden");

    // Function to toggle visibility of filter items and update the link text
    function toggleFilterItems() {
      // Loop through each hidden filter item and toggle its visibility
      filterItems.forEach((item) => {
        item.classList.toggle("filter-item--hidden");
      });

      // Check if there are any hidden items left
      let isHidden = filterItems[0].classList.contains("filter-item--hidden");
      if (isHidden) {
        seeMoreLink.textContent = "See more"; // Change text to "See more" if items are hidden
      } else {
        seeMoreLink.textContent = "See less"; // Change text to "See less" if items are shown
      }
    }

    // Add event listener to "See more"/"See less" link
    if (seeMoreLink) {
      seeMoreLink.addEventListener("click", function (e) {
        e.preventDefault(); // Prevent default action of the link
        toggleFilterItems(); // Toggle the filter items visibility
      });
    }
  });
});

// pointer events none on mega menu untill first time mouse move
window.addEventListener('DOMContentLoaded', () => {
  const megaMenus = document.querySelectorAll('.mega-menu');

  // Disable pointer events on all .mega-menu elements
  megaMenus.forEach(menu => {
    menu.style.pointerEvents = 'none';
  });

  // Wait until user moves the mouse
  const enableHover = () => {
    megaMenus.forEach(menu => {
      menu.style.pointerEvents = 'auto';
    });

    // Only run this once
    window.removeEventListener('mousemove', enableHover);
  };

  window.addEventListener('mousemove', enableHover);
});

 document.addEventListener('DOMContentLoaded', () => {
    const contents = document.querySelectorAll('.mega-menu__content');

    // Immediately hide all menus before they flash
    contents.forEach(content => {
      content.style.display = 'none';
      content.style.opacity = '0';
      content.style.pointerEvents = 'none';
    });

    const enableMenus = () => {
      contents.forEach(content => {
        content.style.display = '';
        content.style.opacity = '';
        content.style.pointerEvents = '';
      });
      window.removeEventListener('mousemove', enableMenus);
    };

    window.addEventListener('mousemove', enableMenus);
  });













